export const data = [
    {
        "company": "Photosnap",
        "photecompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037861/samples/job_listings_with_filtering/photosnap_cvn7ts.svg ",
        "profile": "Senior Frontend Developer",
        "time": "1d ago",
        "workingDay": "Full Time",
        "site": "USA only",
        "skills":["Frontend", "Senior", "HTML", "CSS" , "JavaScript"],
        "id": 1
    },
    {
        "company": "Manage",
        "photecompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037859/samples/job_listings_with_filtering/manage_ujmbwv.svg",
        "profile": "Fullstack Developer",
        "time": "1d ago",
        "workingDay": "Part Time",
        "site": "Remote",
        "skills":["Fullstack", "Midweight", "Python", "React" ],
        "id": 2
    },
    {
        "company": "Account",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037857/samples/job_listings_with_filtering/account_v8aguy.svg",
        "profile": "Junior Frontend Developer",
        "time": "2d ago",
        "workingDay": "Part Time",
        "site": "USA only",
        "skills":["Frontend", "Junior", "React", "Sass" , "JavaScript"],
        "id": 3
    },
    {
        "company": "Myhome",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037860/samples/job_listings_with_filtering/myhome_n881al.svg",
        "profile": "Junior Frontend Developer",
        "time": "5d ago",
        "workingDay": "Contract",
        "site": "USA only",
        "skills":["Frontend", "Junior", "CSS" , "JavaScript"],
        "id": 4
    },
    {
        "company": "Loop Studios",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037860/samples/job_listings_with_filtering/loop-studios_kxkdsq.svg",
        "profile": "Software Engineer",
        "time": "1w ago",
        "workingDay": "Full Time",
        "site": "Worldwide",
        "skills":["Fullstack", "Midweight", "JavaScript", "Sass", "Ruby"],
        "id": 5
    },
    {
        "company": "Faceit",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037858/samples/job_listings_with_filtering/faceit_umuchg.svg",
        "profile": "Junior Backend Developer",
        "time": "2w ago",
        "workingDay": "Full Time",
        "site": "UK only",
        "skills":["Backend", "Junior", "Ruby", "RoR" ],
        "id": 6
    },
    {
        "company": "Shortly",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037862/samples/job_listings_with_filtering/shortly_pqvpwd.svg",
        "profile": "Junior Developer",
        "time": "2w ago",
        "workingDay": "Full Time",
        "site": "Worldwide",
        "skills":["Frontend", "Junior", "HTML", "Sass", "JavaScript"],
        "id": 7
    },
    {
        "company": "Insure",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037859/samples/job_listings_with_filtering/insure_dtfprv.svg",
        "profile": "Junior Frontend Developer",
        "time": "2w ago",
        "workingDay": "Full Time",
        "site": "USA only",
        "skills":["Frontend", "Junior", "Vue", "JavaScript", "Sass"],
        "id": 8
    },
    {
        "company": "Eyecam-co",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037857/samples/job_listings_with_filtering/eyecam-co_pmmm0s.svg",
        "profile": "Full Stack Engineer",
        "time": "3w ago",
        "workingDay": "Full Time",
        "site": "Worldwide",
        "skills":["Fullstack", "Midweight", "JavaSript", "Django" , "Python"],
        "id": 9
    },
    {
        "company": "The Air Filter Company",
        "photeCompany": "https://res.cloudinary.com/dss4kjwzk/image/upload/v1646037861/samples/job_listings_with_filtering/the-air-filter-company_ziyfds.svg",
        "profile": "Front-end Dev",
        "time": "1mo ago",
        "workingDay": "Part Time",
        "site": "Worldwide",
        "skills":["Frontend", "Junior", "React", "Sass", "JavaScript"],
        "id": 10
    }
    
]

